import React, { useContext, useEffect, useState } from 'react';
import './TrialTopHeader.css';
import $ from 'jquery';
import { useDebounce } from '../../hooks/useDebounce';
import tooltipIcon from './images/alert-circle.svg';
import closeIcon from './images/close-x.svg';
import { AppDataContext } from '../../utils';

export const TrialTopHeader = ({
  fixedClassNamesToMove = '',
  descriptionText,
  pillDisplayText,
  tooltipText,
  handleClick,
  spaUsesMentorSidebar = false,
}) => {
  const { appData } = useContext(AppDataContext);
  const [visible, setVisible] = useState(false);
  const handleJSScripts = () => {
    //TOOLTIP HANDLE
    $('.top-header-icon-container').on('mouseover', function () {
      $(this).find('.tooltip-trial').show();
    });
    $('.top-header-icon-container').on('mouseout', function () {
      $(this).find('.tooltip-trial').hide();
    });
    //ADDITIONAL ELEMENTS TO MOVE DOWN
    if (fixedClassNamesToMove !== '') {
      $(fixedClassNamesToMove).css('top', '+=30');
    }
    $('body').css('padding-top', '+=30');

    //ON TRIAL CLOSURE
    $(document).on('click', '.top-header-closer-container', function () {
      $('.ibl-trial-top-header').hide();
      $('body').css('padding-top', '-=30');
      if (fixedClassNamesToMove !== '') {
        $(fixedClassNamesToMove).css('top', '-=30');
      }
    });
  };

  useEffect(() => {
    if (spaUsesMentorSidebar) {
      if (appData?.sidebarCopilotTriggered) {
        //Copilot should be triggered first before toptrialheader shows up
        setVisible(true);
      }
    } else {
      setVisible(true);
    }
  }, [appData?.sidebarCopilotTriggered]);

  useDebounce(
    () => {
      if (visible) {
        handleJSScripts();
      }
    },
    200,
    [visible]
  );

  return (
    visible && (
      <div className="site-top-header ibl-trial-top-header">
        <div className="w-layout-hflex site-top-header-container">
          <div
            data-w-id="16213f3d-be52-d559-0a8b-d87aa0856154"
            className="w-layout-hflex top-header-icon-container"
          >
            <img
              src={tooltipIcon}
              loading="lazy"
              height="20"
              alt=""
              className="top-header-img"
            />
            <div className="tooltip tooltip-trial" style={{ display: 'none' }}>
              {tooltipText}
            </div>
          </div>
          <div className="top-header-text">{descriptionText}</div>
          <a
            href="#"
            onClick={() => handleClick()}
            className="top-header-question-link w-inline-block"
          >
            <div className="top-header-text pill">{pillDisplayText}</div>
          </a>
          <div
            prop-events-value-onclick="handleTopHeaderCloseClick"
            prop-events-names="onClick"
            className="w-layout-hflex top-header-closer-container"
          >
            <img
              src={closeIcon}
              loading="lazy"
              alt=""
              className="top-header-closer-icon"
            />
          </div>
        </div>
      </div>
    )
  );
};
